import '../../scss/pages/catalog.scss';
import Modal from 'bootstrap/js/dist/modal';
import Popover from "bootstrap/js/dist/popover";
const ModalMarketPlace = new Modal('#marketPlaceModal', {
    keyboard: false
})

const PartnerUsTitle=document.querySelector('#partner-us-title');
const titleHolderMobile=document.querySelector('.partner-with-us__title-mobile');
const titleHolderDesktop=document.querySelector('.partner-with-us__title-desktop');

let catalogShowFrom=document.querySelector('#catalogShowFrom');
let catalogTotalProduct=document.querySelector('#catalogTotalProduct');


window.almOnLoad = function(alm){
	console.log("Ajax Load More is now loaded");
   catalogTotalProduct.innerHTML=alm.totalposts
};

window.almComplete = function(alm){
    let tokopediaURL= catalogData.tokopediaLogo_url
    let shopeeURL= catalogData.shopeeLogo_url
    let cardProducts=document.querySelectorAll('.card-product');
    let cardMarketPlaceContainer=document.querySelector('#cardMarketPlaceContainer')
    cardProducts.forEach(n => n.addEventListener('click', function (event) {
        event.preventDefault()
        let productID=n.dataset.id
        let dataTokopedia=n.dataset.tokopedia
        let dataShopee=n.dataset.shopee
        let cardMarketPlaceMarkup='';
        if(dataTokopedia!=''){
            cardMarketPlaceMarkup +=` <a class="card-marketplace" href="${dataTokopedia}">
            <img class="card-marketplace__image" src="${tokopediaURL}">
        </a>`
        }
        if(dataShopee !=''){
            cardMarketPlaceMarkup +=` <a class="card-marketplace"  href="${dataShopee}">
            <img class="card-marketplace__image"  src="${shopeeURL}">
        </a>`
        }
        ModalMarketPlace.show()
        cardMarketPlaceContainer.innerHTML=cardMarketPlaceMarkup;

    }))
   // console.log(alm);
    catalogShowFrom.innerHTML=cardProducts.length
    catalogTotalProduct.innerHTML=alm.totalposts
    


    
};

window.addEventListener("load", function () {
    if (window.innerWidth <= 767) {
        titleHolderMobile.append(PartnerUsTitle)
	} else {
		titleHolderDesktop.append(PartnerUsTitle)
	}
});

window.addEventListener("resize", function(){
    if (window.innerWidth <= 767) {
        titleHolderMobile.append(PartnerUsTitle)
	} else {
		titleHolderDesktop.append(PartnerUsTitle)
	}
});


